export const transformCardStyle = {
  transform: "scale(.35)",
  transformOrigin: "0% 0% 0px",
}